import { useLingui } from '@lingui/react/macro';
import { styled } from '@linaria/react';
import { Button } from 'app-ui/primitives/input';
import { Heading, Text } from 'app-ui/primitives/typography';
import { themeCssVariables } from 'app-ui/theme';
import { type FallbackProps } from 'react-error-boundary';

// Fills whatever holds it: the whole window, or the page card when a single
// page crashes.
const StyledContainer = styled.div`
  align-items: center;
  background: ${themeCssVariables.background.primary};
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${themeCssVariables.spacing[3]};
  justify-content: center;
  padding: ${themeCssVariables.spacing[8]};
  text-align: center;
`;

type AppErrorFallbackProps = FallbackProps;

export const AppErrorFallback = ({
  resetErrorBoundary,
}: AppErrorFallbackProps) => {
  const { t } = useLingui();

  const handleRetryClick = () => {
    resetErrorBoundary();
  };

  return (
    <StyledContainer role="alert">
      <Heading>{t`Something went wrong`}</Heading>
      <Text>{t`Please try again. If the problem continues, contact support.`}</Text>
      <Button onClick={handleRetryClick}>{t`Try again`}</Button>
    </StyledContainer>
  );
};
